export default "__VITE_ASSET__PnPECIpL__"